import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Plus } from 'lucide-react';

interface LayerPanelProps {
  children: React.ReactNode;
  blockCount: number;
  /** Opens the top-level add-component picker. */
  handleInitAdd: () => void;
}

export default function LayerPanel({
  children,
  blockCount,
  handleInitAdd,
}: LayerPanelProps) {
  return (
    <div className="flex h-full min-h-0 flex-col rounded">
      <div className="grow overflow-y-auto">
        <div className="flex justify-between p-2">
          <span className="text-sm">PAGE OUTLINE</span>
          <span className="text-sm text-zinc-500">
            {blockCount} {blockCount === 1 ? 'block' : 'blocks'}
          </span>
        </div>
        <div>{children}</div>
      </div>
      <div className="border-t border-gray-200 p-2">
        <Button
          size="sm"
          variant="outline"
          className="w-full"
          onClick={handleInitAdd}
        >
          <Plus size={14} />
          Add
        </Button>
      </div>
    </div>
  );
}
